<template>
  <section class="index-page">
    <div class="index-content">
      <PageHeader v-if="yearAllSalesVo" :yearAllSalesVo="yearAllSalesVo"></PageHeader>
      <div class="header-content">
        <EchartMap></EchartMap>
        <Ranking class="header-rank" :regionSalesVoList="regionSalesVoList"></Ranking>
      </div>
      <div class="page-block-content">
        <div class="page-content-left">
          <WangLuoLingShou v-if="retailScaleVo" :retailScaleVo="retailScaleVo"></WangLuoLingShou>
          <NianDuWangLuoLingShou v-if="yearRetailTrendVoList"
                                 :yearRetailTrendVoList="yearRetailTrendVoList"></NianDuWangLuoLingShou>
          <ChanPinManYiDu v-if="productSatisfactionVoList"
                          :productSatisfactionVoList="productSatisfactionVoList"></ChanPinManYiDu>
          <XiaoFeiZheDongCha v-if="customerAnalysisList" :customerAnalysisList="customerAnalysisList"></XiaoFeiZheDongCha>
          <ZhiNengJianBao v-if="smartReportVoList" :smartReportVoList="smartReportVoList"></ZhiNengJianBao>
<!--          供给优化-->
          <GongJiYouHua v-if="provideOptimizeVoList" :provideOptimizeVoList="provideOptimizeVoList"></GongJiYouHua>
        </div>
        <div class="page-content-right">
          <ShiShiDongTai v-if="realTimeOrderCount" :realTimeOrderCount="realTimeOrderCount"></ShiShiDongTai>
          <FenShiDanLiang v-if="timeOrderCountVoList" :timeOrderCountVoList="timeOrderCountVoList"></FenShiDanLiang>
          <MiJuShiChan v-if="marketPriceVoList" :marketPriceVoList="marketPriceVoList"></MiJuShiChan>
          <PinLeiDongCha v-if="categoryAnalysisVoList" :categoryAnalysisVoList="categoryAnalysisVoList"></PinLeiDongCha>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "@/components/page-header.vue";
import EchartMap from "@/components/echart-map.vue";
import PageBlock from "@/components/page-block.vue";
import Ranking from "@/components/ranking.vue";
// 网络零售
import WangLuoLingShou from "@/components/wang-luo-ling-shou.vue";
// 年度网络零售趋势图
import NianDuWangLuoLingShou from "@/components/nian-du-wang-luo-ling-shou.vue";
// 产品满意度
import ChanPinManYiDu from "@/components/chan-pin-man-yi-du.vue";
//消费者洞察
import XiaoFeiZheDongCha from "@/components/xiao-fei-zhe-dong-cha.vue";
// 实时动态
import ShiShiDongTai from "@/components/shi-shi-dong-tai.vue";
// 分时单量趋势图
import FenShiDanLiang from "@/components/fen-shi-dan-liang.vue";
// 蜜橘市场
import MiJuShiChan from "@/components/mi-ju-shi-chan.vue";
// 智能简报
import ZhiNengJianBao from "@/components/zhi-neng-jian-bao.vue";
// 品类洞察
import PinLeiDongCha from "@/components/pin-lei-dong-cha.vue";
// 供给优化
import GongJiYouHua from "@/components/gong-ji-you-hua.vue";
export default {
  name: 'index',
  components: {
    XiaoFeiZheDongCha,
    NianDuWangLuoLingShou,
    Ranking,
    ShiShiDongTai,
    ChanPinManYiDu,
    PageHeader,
    EchartMap,
    WangLuoLingShou,
    MiJuShiChan,
    FenShiDanLiang,
    ZhiNengJianBao,
    PinLeiDongCha,
    GongJiYouHua
  },
  props: {},
  data() {
    return {
      yearAllSalesVo: null,
      regionSalesVoList: null,
      retailScaleVo: null, // 网络销售规模
      yearRetailTrendVoList: null,
      productSatisfactionVoList: null, //产品满意度
      hotWord: null,
      customerAnalysisList: null,
      realTimeOrderCount: null,
      timeOrderCountVoList: null,
      marketPriceVoList: null,
      smartReportVoList: null,
      provideOptimizeVoList: null,
      categoryAnalysisVoList: null
    };
  },
  created() {
    this.getData()
    setInterval(() => {
      this.getData()
    }, 5000)
  },
  methods: {
    async getData() {
      let res = await this.$http.get('largeScreen/getLargeScreenData')
      if (res.data.code === 200) {
        console.log(res.data.data, 222222);
        this.yearAllSalesVo = res.data.data.yearAllSalesVo // 年累计销售额
        this.regionSalesVoList = res.data.data.regionSalesVoList // 排行数据
        this.retailScaleVo = res.data.data.retailScaleVo // 网络销售规模
        this.yearRetailTrendVoList = res.data.data.yearRetailTrendVoList // 网络销售规模
        this.productSatisfactionVoList = res.data.data.productSatisfactionVoList // 网络销售规模
        this.hotWord = res.data.data.hotWord // 网络销售规模
        this.customerAnalysisList = res.data.data.customerAnalysisList // 网络销售规模
        this.realTimeOrderCount = res.data.data.realTimeOrderCount // 网络销售规模
        this.timeOrderCountVoList = res.data.data.timeOrderCountVoList // 分时单量趋势图
        this.marketPriceVoList = res.data.data.marketPriceVoList // 市场行情
        this.smartReportVoList = res.data.data.smartReportVoList // 智能简报
        this.provideOptimizeVoList = res.data.data.provideOptimizeVoList // 供给优化
        this.categoryAnalysisVoList = res.data.data.categoryAnalysisVoList // 品类洞察
      }
    }
  }
};
</script>

<style scoped lang="scss">
.index-page {
  //display: flex;
  //flex-direction: column;
  //justify-content: center;
  //align-items: center;
  background-color: rgb(5,33,66);
  .index-content {
    max-width: 960px;
    margin: auto;
  }

  .header-content {
    position: relative;
    width: 100%;
  }
  .page-block-content {
    display: flex;
    width: 90%;
    gap: 12px;
    padding-bottom: 24px;
    margin: auto;
    .page-content-left, .page-content-right {
      display: flex;
      flex-direction: column;
      //flex: 1;
      gap: 14px;
      flex: 1 1 50%; /* 每个项目占50%宽度，在小屏幕上自动换行 */
    }
  }
}
@media (max-width: 768px) {
  .header-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .header-rank {
      margin-bottom: 12px;
      //width: 100%;
    }
  }
  .page-block-content {
    display: flex;
    width: 90%;
    gap: 12px;
    flex-direction: column;
  }
}
</style>
